import React, { useContext, useEffect, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import '../assets/style/howToAnswerModal.css';
import thumbsup from "../assets/images/thumbs-up.svg";
import activeThumsUp from "../assets/images/activeThumsUp.svg";
import thumbsdown from "../assets/images/thumbs-down.svg";
import activethumpsdown from "../assets/images/thumbsdownWhitediff.svg";
import arrowright from "../assets/images/arrow-right.svg";
import Satisfied from "../assets/images/satisfied.svg";
import Enthusiastic from "../assets/images/Enthusiastic.svg";
import Diplomatic from "../assets/images/diplomatic.svg";
import Cautious from "../assets/images/Cautious.svg";
import DropdownLanguage from '../pages/multiLang/DropDown';
import { lungueges } from '../constant/lungueges';
import { AppContext } from "../contaxt/AppContext";
import globe from "../assets/images/globe-01.svg";
import arrowUp from "../assets/images/ChevronUp.svg";
import intermiodeate from "../assets/images/Indeterminatequestionbox.svg";
import closeIcon from "../assets/images/closeIcon.svg";
import { useSelector } from 'react-redux';


const HowToAnswerModal = ({ show, onHide, isMobileView }) => {

    const state = useSelector(state => state.roundData)

    const cards = [
        { id: 1, label: 'Daring', img: Cautious },
        { id: 2, label: 'Satisfied', img: Satisfied },
        { id: 3, label: 'Enthusiastic', img: Enthusiastic },
        { id: 4, label: 'Good Natured', img: Diplomatic },
    ];

    // Track the status of each card: 'like', 'dislike', or null
    // const [cardStatus, setCardStatus] = useState({});
    // const [likeCardId, setLikeCardId] = useState(null);
    // const [dislikeCardId, setDislikeCardId] = useState(null);

    // Preselect Daring as liked and Satisfied as disliked
    const [cardStatus, setCardStatus] = useState({
        1: 'like',
        2: 'dislike',
    });
    const [likeCardId, setLikeCardId] = useState(1);
    const [dislikeCardId, setDislikeCardId] = useState(2);


    const handleLike = (id) => {
        if (cardStatus[id] === 'like') {
            // Clicking the same like should deselect
            setCardStatus((prev) => ({ ...prev, [id]: null }));
            setLikeCardId(null);
        } else {
            // Remove previous like
            if (likeCardId) {
                setCardStatus((prev) => ({ ...prev, [likeCardId]: null }));
            }

            // If this card was previously disliked, remove the dislike
            if (dislikeCardId === id) {
                setDislikeCardId(null);
            }

            // Apply like to current card
            setCardStatus((prev) => ({ ...prev, [id]: 'like' }));
            setLikeCardId(id);
        }
    };

    const handleDislike = (id) => {
        if (cardStatus[id] === 'dislike') {
            // Clicking the same dislike should deselect
            setCardStatus((prev) => ({ ...prev, [id]: null }));
            setDislikeCardId(null);
        } else {
            // Remove previous dislike
            if (dislikeCardId) {
                setCardStatus((prev) => ({ ...prev, [dislikeCardId]: null }));
            }

            // If this card was previously liked, remove the like
            if (likeCardId === id) {
                setLikeCardId(null);
            }

            // Apply dislike to current card
            setCardStatus((prev) => ({ ...prev, [id]: 'dislike' }));
            setDislikeCardId(id);
        }
    };

    const getBorderColor = (id) => {
        if (cardStatus[id] === 'like') return '#444CE7';
        if (cardStatus[id] === 'dislike' && state?.isNormalAssesment) return '#F97066';
        return '#e3e8f0';
    };

    const likedCard = cards.find((card) => card.id === likeCardId);
    const dislikedCard = cards.find((card) => card.id === dislikeCardId);

    const dropdownRef1 = useRef(null);

    const { ChangeLang } = useContext(AppContext);
    const [showDropDown, setShowDropDown] = useState(false);

    const handleDropDown = () => {
        setShowDropDown(!showDropDown);
    };

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <Modal show={show} size="lg" centered>
            <div className="ModalcloseBtn" >
                <h4 className="mb-0"></h4>
                <img src={closeIcon} className="mobIcon mt-3 me-3" alt="" onClick={onHide} />
            </div>
            {/* <img src={closeIcon} className="mobIcon d-flex justify-content-end" alt="" /> */}
            <div className='sec-wraptitl' >
                <Modal.Header className="text-center justify-content-center modal-header-sx" style={{ paddingBottom: "0px" }}>
                    <Modal.Title className='modal-title-sx how-ansr-mod' style={{ fontFamily: 'Inter-Regular' }}>
                        {
                            state.isNormalAssesment ? "How to Answer The Behaviour Test ?" : "Short Personality Test"}</Modal.Title>


                </Modal.Header>
                <div className='d-flex justify-content-center'>
                    {/* <img src={intermiodeate} className=' me-2' style={{width:"28px", height:"20px"}}/> */}

                    <p className='text-center justify-content-center how-ansr-modnew'>{isMobileView ? !state?.isNormalAssesment ? "Short Personality Test" : "You’ll be answering a total of 28 Question sets" : `You’ll be answering a total ${state?.isNormalAssesment ? '28' : '14'} of  Question sets`}</p></div>
            </div>

            <Modal.Body className='modal-body-sx'>

                <div className='sec-wrap'>

                    {
                        state?.isNormalAssesment &&

                        <div className='instrctn-sec'>

                            {/* <div className='numWrap'>1</div> */}
                            <div style={{ width: "80%" }}>
                                <h6>Each question has 4 options</h6>
                                <p>You’ll see 4 Cards with simple descriptions.</p>
                            </div>
                        </div>
                    }
                    {
                        state?.isNormalAssesment ?
                            <>
                                <div className='instrctn-sec'>
                                    {/* <div className='numWrap'>2</div> */}
                                    <img
                                        src={activeThumsUp}
                                        className="thumbsup-box-actv-1"
                                        alt="Thumbs Up"
                                    />
                                    <div style={{ width: "80%" }}>
                                        <div className='txt-icon-sec'>
                                            <h6>Select one "Most Like You"</h6>

                                        </div>
                                        <p>Click the “thumbs up” button under any card which you feel best describes you</p>
                                    </div>
                                </div>
                                <div className='instrctn-sec'>
                                    {/* <div className='numWrap'>2</div> */}
                                    <img
                                        src={activethumpsdown}
                                        className="thumbsdown-box-actv-1"
                                        alt="Thumbs Down"
                                    />
                                    <div style={{ width: "80%" }}>
                                        <div className='txt-icon-sec'>
                                            <h6>Select one "Least Like You"</h6>

                                        </div>
                                        <p>Click the “thumbs down” button under any card which you feel least describes you </p>
                                    </div>
                                </div>
                            </>
                            :
                            <div className='instrctn-sec'>
                                <div>
                                    <p>14 Sets of Images & Words</p>
                                    <p>Select one that you most relate to each in set</p>
                                    <p>Complete all 14 to submit</p>
                                    <p>You Can Save and return any time</p>
                                </div>
                            </div>
                    }
                    {/* <div className='instrctn-sec'>
                        <div className='numWrap'>3</div>
                        <div style={{ width: "80%" }}>
                            <div className='txt-icon-sec'>
                                <h6>Select one "Least Like You"</h6>
                                <img
                                    src={activethumpsdown}
                                    className="thumbsdown-box-actv-1"
                                    alt="Thumbs Down"
                                />
                            </div>
                            <p>Click the “thumbs down” button under any card which you feel least describes you </p>
                        </div>
                    </div> */}
                </div>


                <div className='ARW-sec'>
                    {
                        state.isNormalAssesment &&
                        <h5>Answering the Right Way :</h5>
                    }
                    <div className='ARW-box-wrap'>

                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            {[0, 2].map((startIndex) => (
                                <div key={startIndex} className='card-sx-wrap'>
                                    {cards.slice(startIndex, startIndex + 2).map((card) => (
                                        <div key={card.id} className="card-sx" style={{ border: `1px solid ${getBorderColor(card.id)}` }}>
                                            <div className='card-inside-wrap'>
                                                <img src={card.img} className="card-img-sx" alt="" />
                                                <div>
                                                    <p style={{ fontFamily: 'Inter-Regular' }}>{card.label}</p>
                                                    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                                                        {
                                                            state?.isNormalAssesment &&

                                                            <img
                                                                src={cardStatus[card.id] === 'dislike' ? activethumpsdown : thumbsdown}
                                                                className={cardStatus[card.id] === 'dislike' ? 'thumbsdown-box-actv' : 'thumbsdown-box'}
                                                                alt="Thumbs Down"
                                                                // onClick={() => handleDislike(card.id)}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        }
                                                        <img
                                                            src={cardStatus[card.id] === 'like' ? activeThumsUp : thumbsup}
                                                            className={cardStatus[card.id] === 'like' ? 'thumbsup-box-actv' : 'thumbsup-box'}
                                                            alt="Thumbs Up"
                                                            // onClick={() => handleLike(card.id)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                        {
                            state?.isNormalAssesment &&

                            <div className="answr-box">
                                <h5>Your Answer</h5>
                                <div className='mb-2'>
                                    <p>Most Like Me:</p>
                                    <h6 className='most-like-colr'>{likedCard ? likedCard.label : 'None'}</h6>
                                </div>
                                <div>
                                    <p>Least Like Me:</p>
                                    <h6 className='least-like-colr'>{dislikedCard ? dislikedCard.label : 'None'}</h6>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer className="justify-content-between modal-footer-sx">

                <div className="lang-sec-modl">
                    <p>
                        {isMobile ? '' : "Select Language"}
                    </p>
                    <div
                        className="d-flex flex-column postion-relative"
                        ref={dropdownRef1}
                    >
                        <div
                            className="langTxtInrBox"
                            onClick={handleDropDown}
                            style={{ cursor: "pointer" }}
                        >
                            <p className="lang-txt">
                                {
                                    lungueges[ChangeLang] ? lungueges[ChangeLang] : 'English'
                                }

                            </p>
                            <img src={arrowUp} className="mobIcon" alt="Select language" />
                        </div>
                        <div
                            className="border ms-1 mt-1 bg-white rounded-3"
                            style={{ position: "absolute", bottom: "55px", left: isMobile ? "" : "143px" }}
                        >
                            {showDropDown && (
                                <DropdownLanguage
                                    showDropDown={showDropDown}
                                    setShowDropDown={setShowDropDown}
                                />
                            )}
                        </div>
                    </div>
                </div>

                <div className='footer-button' style={{cursor:"pointer"}} onClick={onHide}>
                    {isMobile ? 'LET’S GO' : "Got it! Let's Start"}
                    <img
                        src={arrowright}
                        className="arrow-rgt"
                        alt="arrow right"
                    />
                </div>


            </Modal.Footer>
        </Modal>
    );
};

export default HowToAnswerModal;


